function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16 4L4.00007 15.9999",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L4.00007 4.00007",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close_grey.de96d7dee1030ad8a5fefd5cc5b52c2d.svg";
export { ForwardRef as ReactComponent };